<script setup lang="ts">
type MeatProps = {
  isOutline: boolean
  styles: {
    top: string
    left: string
    transform: string
    position: 'absolute' | 'fixed'
  }
  color?: string
}

const props = defineProps<MeatProps>()

const getColor = (defaultColor: string) => {
  return props.color ? props.color : defaultColor
}
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 844.37 436.46"
    :style="styles"
    class="-z-1 h-[25vh] w-[25vh] overflow-hidden"
  >
    <g id="a" />
    <g id="b" />
    <g id="c" />
    <g id="d" />
    <g id="e">
      <path
        class="u"
        :fill="getColor('#de6852')"
        :fill-opacity="isOutline ? 0 : 1"
        :stroke-width="isOutline ? 10 : 0"
        stroke="#FFFFFF"
        d="M467.13,91.44c-41.34-12.99-83.93-21.86-124.93-37.27C299.46,38.1,252.34,1.78,204.63,8.67c-40.51,5.86-79.49,.03-108.53,32.15C57.84,83.13,26.19,159.65,11.48,215.08c-10.82,40.76,3.72,71.01,25.28,103.76,16.17,24.55,20.55,56.95,36.14,79.29,19.85,28.43,56.83,25.86,86.59,24.97,62.25-1.85,124.03,5.58,187.42,2.59,107.31-5.05,213.82-2.72,320.22-7.68,68.17-3.18,107.96-37.1,147.2-83.81,13.76-16.38,24.13-25.34,20.94-46.62-2.1-14.01-11.18-37.04-14.76-51.96-10.95-45.64-63.4-58.1-104.58-72.79-75.67-27-168.52-31.56-248.81-71.4Z"
      />
    </g>
    <g id="f" />
    <g id="g" />
    <g id="h" />
    <g id="i" />
    <g id="j">
      <g id="k" />
      <g id="l" />
      <g id="m" />
      <g id="n" />
      <g id="o" />
      <g id="p" />
      <g id="q" />
      <g id="r" />
      <g id="s" />
      <g id="t" />
    </g>
  </svg>
</template>

<style scoped></style>
